/**
 * useDeleteSite hook
 *
 * TanStack mutation that DELETEs a site. On success, invalidates the
 * `['sites']` list and removes the per-site `['sites', siteId]` cache so
 * stale detail data isn't read after navigation.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/sdk';

export function useDeleteSite() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (siteId) => api.delete<void>(`/api/sites/${encodeURIComponent(siteId)}`),
    onSuccess: (_, siteId) => {
      queryClient.invalidateQueries({ queryKey: ['sites'] });
      queryClient.removeQueries({ queryKey: ['sites', siteId] });
    },
  });
}
